import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPageData } from "../../../redux/pageSlice";
import "./OurStory.css";
import { useVisibilityOnScroll } from "../../../Component/Hooks/useVisibilityOnScroll/useVisibilityOnScroll";
import VisibilitySection from "../../../Component/Hooks/useVisibilityOnScroll/VisibilitySection";
import OurStoryBox from "../../../Component/ReuseComponent/OurStoryBox/OurStoryBox";
import TC3L from "../../../Component/ReuseComponent/TCLines/TC3L";
import { LoaderWrap } from "../../../Component/GlobalLoader/LoaderWrap";
export default function OurStoryArContent() {
  const { sectionsRef, visibilityStates } = useVisibilityOnScroll();

  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.page);

  useEffect(() => {
    dispatch(fetchPageData({ page_id: 2, lang: "ar" }));
  }, [dispatch]);

  const section1 = data.find((s) => s.section_id === "1");
  const section2 = data.find((s) => s.section_id === "2");

  return (
    <>
      <LoaderWrap>
        <div className="OurStoryContainer">
          <section>
            <OurStoryS1 section={section1} />
          </section>
          <VisibilitySection index={1} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="OurStoryS2">
            <OurStoryS2 section={section1} />
          </VisibilitySection>
          <VisibilitySection index={2} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="OurStoryS3">
            <OurStoryS3 section={section2} />
          </VisibilitySection>
          <VisibilitySection index={3} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="OurStoryS4">
            <OurStoryS4 contents={section2?.contents} />
          </VisibilitySection>
        </div>
      </LoaderWrap>
    </>
  );
}
function OurStoryS1({ section }) {
  const sentences = section?.description?.split(".").filter(Boolean) || [];

  const Para =
    sentences
      .slice(0, 2)
      .map((s) => s.trim())
      .join(".<br /><br />") + ".";

  const ParaS =
    sentences
      .slice(2)
      .map((s) => s.trim())
      .join(".<br /><br />") + ".";
  return (
    <>
      <div className="OurStoryS1">
        <TC3L
          Head="قصتنا"
          Title={section?.title}
          Para={
            <>
              <div dangerouslySetInnerHTML={{ __html: Para }} />
            </>
          }
          ParaS={<div dangerouslySetInnerHTML={{ __html: ParaS }} />}
          ParaWidth="56vw"
        />
      </div>
    </>
  );
}
function OurStoryS2({ section }) {
  return (
    <>
      <div className="OurStoryS2">
        <img src={section?.image} alt="Our Story Visual" className="OurStoryS2Img" />
      </div>
    </>
  );
}
function OurStoryS3({ section }) {
  const Para =
    section?.description
      .split(".")
      .map((s) => s.trim())
      .filter(Boolean)
      .join(".<br />") + ".";

  return (
    <div className="OurStoryS1">
      <TC3L Title={section?.title} Para={<div dangerouslySetInnerHTML={{ __html: Para }} />} ParaWidth="56vw" />
    </div>
  );
}

function OurStoryS4({ contents }) {
  return (
    <div className="OurStoryS4">
      {contents?.map((item) => (
        <OurStoryBox
          key={item.id}
          Head={item.title}
          Number={item.description.split(" ")[0]}
          Title={item.description.split(" ").slice(1).join(" ")}
          Image={item.image}
          ImageAlt={item.title}
        />
      ))}
    </div>
  );
}
